import { Directive } from "vue";
import { Keymap, makeHotkey } from "@/scripts/hotkey";

const meta = new WeakMap<WeakKey, HotkeyData>();

type Modifiers = "global";
type HotkeyData = {
    global: boolean;
    handler(ev: KeyboardEvent): void;
};

export default {
    created(el, binding, vnode) {
        meta.set(el, {
            global: binding.modifiers.global ?? false,
            handler: makeHotkey(binding.value),
        });
    },

    beforeMount(el, binding, vnode) {
        const self = meta.get(el);
        if (!self) {
            return;
        }

        if (self.global) {
            document.addEventListener("keydown", self.handler);
        } else {
            el.addEventListener("keydown", self.handler);
        }
    },

    beforeUnmount(el, binding, vnode) {
        const self = meta.get(el);
        if (!self) {
            return;
        }

        if (self.global) {
            document.removeEventListener("keydown", self.handler);
        } else {
            el.removeEventListener("keydown", self.handler);
        }
    },
} satisfies Directive<HTMLElement, Keymap, Modifiers>;
